import { useNavigate } from "react-router-dom";
import { UseGetStoreData } from "../getStoreData/UseGetStoreData";
import { useAmbulanceBooking } from "../useAmbulanceBooking/UseAmbulanceBooking";
import { useTabHandling } from "../useTabHandling/UseTabHandling";
import { useEffect, useState } from "react";
import { useSseTrigger } from "../UseSseTrigger/UseSseTrigger";
import { fetchAmbulance } from "../../pages/actions/actions";
export const useTicketHandlingPart2 = () => {
  const { connectSse } = useSseTrigger();

  const { handleTabSwitch, showOperationTab } = useTabHandling();
  const { getTicketData, getTicketStatus } = UseGetStoreData();
  const { handleTicketUpdate } = useAmbulanceBooking();
  const [ambulanceData, setAmbulanceData] = useState<any[]>([]);
  const [locationData, setLocationData] = useState({
    pickupAddress: "N/A",
    pickupCity: "N/A",
    pickupLabel: "N/A",
    dropLocation: "N/A"
  });

  // console.log('showOperationTab:', showOperationTab);
  const navigate = useNavigate();

  const handleCloseTicket = async () => {
    await handleTicketUpdate("resolve");
    navigate("/");
  };
  const handleDemoCloseTicket = async () => {
    await handleTicketUpdate("demo");
    navigate("/");
  };
  const handleOperationTask = () => {
    navigate("/operations");
  };

  const handleBookAmbulance = () => {
    handleTicketUpdate("bookAmbulance");
  }
  // Helper function to get location data with ambulance priority
  const getLocationData = () => {
    const ambulancePickup = ambulanceData?.length > 0 ? ambulanceData[0]?.pickupLocation : null;
    const ambulanceDrop = ambulanceData?.length > 0 ? ambulanceData[0]?.dropLocation?.[0] : null;
    const ticketPickup = getTicketData?.patientLocation;
    const ticketDrop = getTicketData?.hospitalInfo;

    return {
      pickupAddress: ambulancePickup?.address || ticketPickup?.address || "N/A",
      pickupCity: ambulancePickup?.city || ticketPickup?.city || "N/A",
      pickupLabel: ambulancePickup?.label || ticketPickup?.label || "N/A",
      dropLocation: (ambulanceDrop?.hospitalName ? ambulanceDrop : null) || ticketDrop || ambulanceDrop || "N/A"
    };
  };


  useEffect(() => {
    connectSse();
    async function fetchAmbulanceData() {
      let response = await fetchAmbulance(getTicketData?._id);
      setAmbulanceData(response);

      // Assign location data inside useEffect
      const newLocationData = getLocationData();
      const getPatientPickupAddress = newLocationData.pickupAddress;
      const getPatientPickupCity = newLocationData.pickupCity;
      const getPatientDropLocation = newLocationData.dropLocation;
      const pickupLocationLabel = newLocationData.pickupLabel;

      setLocationData({
        pickupAddress: getPatientPickupAddress,
        pickupCity: getPatientPickupCity,
        dropLocation: getPatientDropLocation,
        pickupLabel: pickupLocationLabel
      });
    }
    fetchAmbulanceData();
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [getTicketData])

  return {
    handleBookAmbulance,
    handleCloseTicket,
    handleDemoCloseTicket,
    handleOperationTask,
    getTicketData,
    getPatientPickupAddress: locationData.pickupAddress,
    getPatientPickupCity: locationData.pickupCity,
    getPatientDropLocation: locationData.dropLocation,
    getTicketStatus,
    handleTabSwitch,
    showOperationTab,
    pickupLocationLabel: locationData.pickupLabel,
    ambulanceData,
    isTicketDemo: getTicketData?.Demo || false,
  };
};
